"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (data) { return Math.max.apply(Math, data); });
//# sourceMappingURL=max.js.map